(function () {
    const occasionSearchForm = document.querySelector(
        '.js-occasion-search-form'
    );
    if (occasionSearchForm === null) {
        return;
    }

    /**
     * Prevent the submit from happening.
     * Instead create a FormData object.
     * This will trigger the formdata event.
     */
    occasionSearchForm.addEventListener('submit', event => {
        new FormData(event.target);
        event.preventDefault();
    });

    /**
     * Filter out any values that contain empty strings.
     * Then construct a new URL and redirect to the target of the form.
     */
    occasionSearchForm.addEventListener('formdata', ({ target, formData }) => {
        for (const [key, value] of formData) {
            if (value === '') {
                formData.delete(key);
            }
        }

        const url = new URL(target.action);
        url.search = new URLSearchParams(formData);

        window.location.href = url;
    });
})();



// WEBPACK FOOTER //
// ./scripts/custom/occasions/occasionSearchForm.js